<template>
  <div
    :class="[
      $style.rewards,
      { [$style.activeText]: reward.isEnabled, [$style.firstReward]: isFirst },
    ]"
  >
    <span>{{ reward.title }}</span>
    <span v-if="reward.value && reward.isEnabled" :class="$style.rewardValue">
      {{ snippet.format(reward.value) }}
    </span>
    <span v-else-if="reward.isEnabled">
      <AwailableRewardIcon width="24" height="24" />
    </span>
    <span v-else>
      <LockIcon width="24" height="24" />
    </span>
  </div>
</template>

<script lang="ts" setup>
import LockIcon from '~/public/images/infopage/vip/lock.svg?component';
import AwailableRewardIcon from '~/public/images/infopage/vip/reward_available.svg?component';
import type { TvipReward } from '~/types/vip';

defineProps({
  reward: {
    type: Object as PropType<TvipReward>,
    required: true,
  },
  isFirst: {
    type: Boolean,
    default: false,
  },
});

const snippet = useSnippet();
</script>

<style lang="scss" module src="./vipRewardRow.scss"></style>
